import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { CustomerService } from '../../services/customer.service'
import { PrintService } from '../../services/print.service'
import { trigger, state, style, transition, animate } from '@angular/animations';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-customers-groups',
	templateUrl: './customers-groups.component.html',
	styleUrls: ['./customers-groups.component.scss']
})
export class CustomersGroupsComponent implements OnInit {
	lineEditRef: any;
	color = 'blue';
	categories: any = [];
	productlines: any = [];
	rebates: any = [];
	hazards: any = [];
	manufacturers: any = [];
	groupForm: UntypedFormGroup;
	search = new UntypedFormControl('');
	searchResults: any = [];
	searching: any = false;
	grouped: any = [];
	customergroups: any = [];
	exporting = false;
	filename = 'CustomerGroups';
	constructor(private customerService: CustomerService, private fb: UntypedFormBuilder, private globalSearchService: GlobalSearchService, private location: Location, public cdr: ChangeDetectorRef, private modalService: NgbModal, private printService: PrintService) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.groupForm = this.fb.group({
			group_id: [''],
			group_name: [''],
			members: ['', Validators.required],
		});

		this.customerService.getGroups().subscribe(results => {
			this.customergroups = results;
		});

		this.globalSearchService.aiDataAvailable$.next(null);
	}

	customerSearch() {
		const value = this.search.value;
		if (this.searching) {
			this.searching.unsubscribe();
		}
		this.searching = this.customerService.getCustomerSearch(value).subscribe((results: any) => {
			this.searchResults = results
		});
	}
	removeGroup(group: any) {

		this.customerService.removeGroup(group.group_id).subscribe(results => {
			this.customergroups = results;
		})
	}
	removeMember(customer: any, group: any) {
		const gindex = this.customergroups.indexOf(group);
		const cindex = this.customergroups[gindex].members.indexOf(customer);
		this.customergroups[gindex].members.splice(cindex, 1)
		this.customerService.removeGroupMember(customer.member_id).subscribe(results => {
			this.customergroups = results;
		})
	}

	removeCustomer(c: any) {
		const index = this.grouped.indexOf(c);
		this.grouped.splice(index, 1);
	}

	addCustomer(customer: any) {

		const member = {
			debtorno: customer.debtorno,
			branch_code: customer.branchcode,
			is_primary: (this.grouped.length) ? 0 : 1,
			name: customer.name,
			member_id: '',
		};

		if (this.grouped.indexOf(member) < 0) {
			this.searchResults = false;
			this.grouped.push(member);
		}
		this.search.setValue('');
		this.groupForm.get('members').setValue(this.grouped);
	}

	addCategory() {

	}

	editGroup(g: any) {

		this.groupForm = this.fb.group({
			group_id: [g.group_id],
			group_name: [g.group_name],
			members: [g.members, Validators.required],
		});

		this.grouped = g.members;
		this.groupForm.get('members').setValue(g.members);

	}

	addGroup() {
		this.customerService.saveGroup(this.groupForm.value).subscribe(results => {
			this.customergroups = results;
			this.grouped = [];
		})
	}

	ngAfterViewInit() {

	}

	back(): void {
		this.location.back()
	}

	generateHtml(): string {
		let html = '<div class="table-responsive"><table class="table table-bordered table-striped table-sm">';
		html += '<thead><tr><th>Group</th><th>Customer #</th><th>Name</th></tr></thead><tbody>';
		this.customergroups.forEach(g => {
			if (g.members && g.members.length) {
				g.members.forEach((m: any, index: number) => {
					html += '<tr>';
					if (index === 0) {
						html += `<td rowspan="${g.members.length}">${g.group_name}</td>`;
					}
					const branch = m.branchcode || m.branch_code || '';
					html += `<td>${m.debtorno}.${branch}</td>`;
					html += `<td>${m.name}</td>`;
					html += '</tr>';
				});
			} else {
				html += `<tr><td>${g.group_name}</td><td colspan="2"></td></tr>`;
			}
		});
		html += '</tbody></table></div>';
		return html;
	}

	exportPdf() {
		this.exporting = true;
		const encoded = this.globalSearchService.base64encode(this.generateHtml());
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			landscape: true,
			title: 'Customer Groups',
			subtitle: 'created ' + today.toLocaleString()
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.exporting = false;
			this.globalSearchService.downloadPdf(result.content, data.filename);
		}, () => this.exporting = false);
	}

	exportXls() {
		this.exporting = true;
		const encoded = this.globalSearchService.base64encode(this.generateHtml());
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Customer Groups',
			subtitle: 'created ' + today.toLocaleString()
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.exporting = false;
			this.globalSearchService.downloadXls(result.content, data.filename);
		}, () => this.exporting = false);
	}

}
